import PropTypes from 'prop-types';
import React from 'react';

export const TRP_CONSTANT = 'T.\u00A0Rowe\u00A0Price';

const TRP = ({ as: Component = 'span', ...props }) => (
  <Component {...props}>{TRP_CONSTANT}</Component>
);

TRP.propTypes = {
  as: PropTypes.string
};

export default TRP;
